/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable camelcase */
/* eslint-disable no-plusplus */
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState, useEffect, useCallback, useRef } from 'react';
import Typography from '@mui/material/Typography';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import {
  Container,
  TextField,
  useTheme,
  Autocomplete,
  FormControl,
  Stack,
  Grid,
  Snackbar,
  Alert,
  Slide,
  Dialog,
  LinearProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  IconButton,
  Checkbox,
  TableCell,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Tooltip,
  FormControlLabel,
} from '@mui/material';
import styled from '@emotion/styled';
import { Link, useNavigate, useParams } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import useMediaQuery from '@mui/material/useMediaQuery';
import noimge from '../../media/noimge.png';
import '../stylemod.css';
import axios from '../../axiosConfig';

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const StyledTableCell = styled(TableCell)({
  fontSize: '14px',
});

const StyledTableHeader = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#8EACCD',
  color: theme.palette.common.white,
  border: '1px solid white',
}));

function formatDate(inputDateTime) {
  const isoDate = new Date(inputDateTime);

  const day = isoDate.getUTCDate().toString().padStart(2, '0');
  const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = isoDate.getUTCFullYear();

  let hour = isoDate.getUTCHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12;

  const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year}`;
}

export default function AddDailyProduction() {
  const { id } = useParams();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const navigate = useNavigate();
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  const [headerData, setHeaderData] = useState(null);
  const [operationSelected, setoperationSelected] = React.useState('');
  const [OperationDataOption, setOperationDataOption] = useState([]);
  const [userData, setUserData] = useState([]);
  const [removeDuplicates, setRemoveDuplicates] = useState('N'); // enable this to remove already added user in operator selection
  const [HoursData, setHoursData] = useState([]);
  const [userselected, setUserSelected] = React.useState('');
  const [Pcs, setPcs] = React.useState('');
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = React.useState('');
  const [lineData, setLineData] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [TSValue, setTSValue] = useState('');
  // ADD OPRATIONS STATES
  const [opGroupSelected, setOpGroupSelected] = useState({ op_group_name: 'All Groups' });
  const [selectedOperations, setSelectedOperations] = useState([]);
  const [OperationData, setOperationData] = useState([]);
  const [opGroupData, setOpGroupData] = useState([]);
  const [FinalPr, setFinalPr] = useState(false);
  const [AllUsersData, setAllUsersData] = useState([]);
  // others
  const [alertType, setAlertType] = useState('success');
  const [openAlert, setopenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [openLoader, setOpenLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [machineData, setMachineData] = useState([]);
  const [TNAid, setTNAid] = useState('');
  const [isDisabled, setIsDisabled] = React.useState(false);
  const [allRecordsData, setallRecordsData] = useState([]);
  const [filter, setFilter] = useState([]);
  const [idState, setIdState] = useState(id);
  const [obSelected, setObSelected] = React.useState(null);
  const [repeatOperation, setRepeatOperation] = React.useState('');
  const [hourChecked, setHourChecked] = React.useState(false);
  const [daywiseEntry, setDaywiseEntry] = useState(false);
  const [dupEmpinDailyProd, setDupEmpinDailyProd] = useState(false);
  const [dailyMaxId, setDailyMaxId] = useState(0);
  const autocompleteRefs = useRef([]);
  const [isLastProduction, setIsLastProduction] = useState(false);
  const formatDateToinitialValues = (date) => {
    if (!date) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const initialFromDate = formatDateToinitialValues(new Date());
  const [date, setDate] = useState(initialFromDate);
  const [fieldErrors, setFieldErrors] = React.useState({
    operationSelected: false,
    userselected: false,
    Pcs: false,
    styleNum: false,
    lineSelected: false,
    remarks: false,
    unitSelected: false,
  });

  const [expanded, setExpanded] = React.useState(true);
  const [selectedHour, setSelectedHour] = React.useState('H1');
  const [tableData, setTableData] = React.useState([]);
  const [InsertDataDetail, setInsertDataDetail] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOperators, setSelectedOperators] = useState({});
  const [setPiecesToZero, setSetPiecesToZero] = useState(false);
  const [originalTableData, setOriginalTableData] = useState([]);
  const [prevOperator, setprevOperator] = useState([]);


  let originalTableData1 = [];

  // When loading data for edit mode, store the original data
  useEffect(() => {
    if (id && tableData.length > 0 && originalTableData.length === 0) {
      setOriginalTableData([...tableData]);
    }
  }, [id, tableData, originalTableData.length]);

  // Get currently assigned operators from table data
  const getAssignedOperatorIds = () => {
    return tableData
      .filter((obj) => obj.Operatorid && obj.Operatorid !== null && obj.Operatorid !== 0)
      .map((obj) => Number(obj.Operatorid));
  };

  // Get previously assigned operators (for edit mode)
  const getPreviousAssignedOperatorIds = () => {
    // You might need to store the original table data when loading for edit
    return originalTableData
      ? originalTableData
        .filter((obj) => obj.Operatorid && obj.Operatorid !== null && obj.Operatorid !== 0)
        .map((obj) => Number(obj.Operatorid))
      : [];
  };

  const [gradeData, setGradeData] = useState([]);

  const GetGradeMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllGradeMstData`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setGradeData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => { }, [searchTerm, filter]);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const resetFields = () => {
    setoperationSelected(null);
    setUserSelected(null);
    setPcs('');
  };

  const handleCheckChange = (event) => {
    setHourChecked(event.target.checked);
  };

  // API Integration
  React.useEffect(() => {
    GetallTNS();
    GetAllOperationMstData();
    GetAllMachineMstData();
    GetOneControl(sessionStorage.getItem('factoryID'));
    GetGradeMstData();
    // if (!id) {
    //   GetAllUser();
    // }

    GetAllActiveOperationGrpData();
    GetAllActiveLineMstData();
  }, []);

  React.useLayoutEffect(() => {
    GetAllActiveProductionUnits();
  }, []);

  // get all Operation Request
  const GetAllOperationMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSearchTerm = (e) => {
    setSearchTerm(e.target.value);
    const filteredData = tableData.filter((enq) => {
      const searchTermLowerCase = searchTerm.toLowerCase();
      return Object.values(enq).some((value) => {
        if (typeof value === 'string') {
          return value.toLowerCase().includes(searchTermLowerCase);
        }
        return false;
      });
    });
    setFilter(filteredData);
  };

  const Gethours = async (ids, prdate) => {
    try {
      const response = await axios.instance.get(`Getallhr/${ids}/DP`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });

      const data = response.data;

      // Filter data by prdate
      const filteredData = data.filter((datas) => formatDate(datas.DailyProddate) === formatDate(prdate));

      let lastdate = '';
      let values = '';
      const hours = [];

      if (!id) {
        if (filteredData.length === 0) {
          setSelectedHour('H1');
          setHoursData([]);
          setDailyMaxId(0);
        } else {
          for (const datas of filteredData) {
            lastdate = datas.CreatedDate;
            values = datas.prhrs;
            hours.push(datas);
          }

          setHoursData(hours);

          const startFrom = values || 'H0';

          if (startFrom.startsWith('H')) {
            const hourValue = parseInt(startFrom.slice(1), 10);
            setSelectedHour(`H${Math.min(hourValue + 1, 12)}`);
          }

          // to load the last production, we are taking the maxid in the collection
          const maxId = Math.max(...hours.map((item) => Number(item.DailyProdheaderid)));
          setDailyMaxId(maxId);
        }
      } else {
        setHoursData(filteredData);
      }
    } catch (error) {
      console.error('Error fetching hours:', error);
    }
  };
  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all group Request
  const GetAllActiveOperationGrpData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationGrpData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOpGroupData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all machine data
  const GetAllMachineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllMachineMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setMachineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all line data
  const GetAllActiveLineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(
        `/GetAllActiveLineMstData/${sessionStorage.getItem('UserID')}/${sessionStorage.getItem('factoryID')}`,
        {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        }
      );
      setLineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const GetOneControl = async (id) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetOneControlCenter/${id}/${sessionStorage.getItem('CompanyId')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      if (res.data.length > 0) {
        res.data.forEach((data) => {
          setDaywiseEntry(data.DaywiseEntry === 'Y');
          setDupEmpinDailyProd(data.DuplicateEmpinDailyProd === 'Y');
        });
      } else {
        setDaywiseEntry(false);
      }
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
    setAlertMessage('');
    setAlertType('success');
  };

  // pre fill data for editing screen
  useEffect(() => {
    const GetoneObHeader = async (ids) => {
      GetOperationBasedTNA(ids);
      setOpenLoader(true);
      try {
        const res = await axios.instance.get(`GetoneTsHeader/${ids}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        setHeaderData(res.data[0]);
        const data = res.data;
        GetAllUser(data[0].Line_id);
        data.forEach((editDataonID) => {
          const { Unit_Id } = editDataonID;
          const selectedunit = unitData.find((obj) => Number(obj.Unit_Id) === Number(Unit_Id));
          setUnitSelected(selectedunit);
        });
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setOpenLoader(false);
      } finally {
        setOpenLoader(false);
      }
    };

    if (!id && idState) {
      GetoneObHeader(idState);
    }
  }, [idState]);

  const GetoneObHeaderEdit = async (ids) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`GetoneTsHeader/${ids}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });

      const resUnit = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const data = res.data;
      GetAllUser(data[0].Line_id);
      setFinalPr(res.data[0].DPcompleted === 'Y');
      setIsDisabled(res.data[0].DPcompleted === 'Y');
      const Unit = resUnit.data;
      data.forEach((editDataonID) => {
        const { Unit_Id } = editDataonID;
        const selectedunit = Unit.find((obj) => Number(obj.Unit_Id) === Number(Unit_Id));
        setUnitSelected(selectedunit);
      });
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    } finally {
      setOpenLoader(false);
    }
  };

  const GetoneHeader = useCallback(async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`GetoneDailyheader/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });

      if (res.data.headerData.length > 0) {
        setHeaderData(res.data.headerData[0]);
        getonedetails(res.data.headerData[0]);
        setIsLastProduction(res.data.detailData[0].LastProduction === 'N');

        res.data.headerData.forEach((editDataonID) => {
          const { TsHeaderid } = editDataonID;
          GetoneObHeaderEdit(TsHeaderid);
          GetOperationBasedTNA(TsHeaderid);
          setDate(editDataonID.DailyProddate);
          setObSelected({
            Tsheaderid: editDataonID.TsHeaderid,
            TsNo: editDataonID.TsNo,
            StyleDescription: editDataonID.StyleDescription,
            StyleNumber: editDataonID.StyleNumber,
            Garment_Description: editDataonID.Garment_Description,
          });

          setSelectedHour(editDataonID.prhrs);
        });

        res.data.headerData.forEach((editDataonID) => {
          const { Unit_Id } = editDataonID;
          const selectedunit = unitData.find((obj) => Number(obj.Unit_Id) === Number(Unit_Id));
          setUnitSelected(selectedunit);
          Gethours(editDataonID.TsHeaderid, editDataonID.DailyProddate);
        });
      }

      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setOpenLoader(false);
    }
  }, [id, unitData]); // ✅ Memoized based on `id` and `unitData`

  useEffect(() => {
    if (id) {
      GetoneHeader();
    }
  }, [id, GetoneHeader]);

  const getonedetails = async (HeaderRetrieveData) => {
    // Edit mode
    try {
      const res = await axios.instance.get(`GetoneDailydetail/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const updatedData = res.data.map((item) => ({
        ...item,
        Pieces: item.Pieces,
        Headerhours: item.Headerhours,
        SalaryPerHour_OnDate:
          item.SalaryPerHour_OnDate === 0
            ? calculateSalaryPerHour(item.Operatorid, HeaderRetrieveData)
            : item.SalaryPerHour_OnDate,
      }));
      setTableData(updatedData);
      originalTableData1 = updatedData;
      setInsertDataDetail(updatedData);

      const datas = updatedData;
      const filterdata = OperationDataOption.filter(
        (obj) => !datas.some((obj1) => obj1.Operationid === obj.Operationid)
      );
      // GetAllUser(datas);
      setOperationDataOption(filterdata);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleDeleteConfirmed = (admId) => {
    setObSelected(TSValue);
    Gethours(TSValue.Tsheaderid, date);
    setIdState(TSValue.Tsheaderid);
    setTableData([]);
    setInsertDataDetail([]);
    setOpenDelete(false);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleFormSubmit = () => {
    const allComplete = tableData.length > 0 &&
      tableData.filter(
        (data) => !Number(data.Operatorid || 0)
      ).length === 0;

    if (allComplete) {
      if (!id) {
        NewDailyProductiom();
      } else {
        UpdateDailyProductiom(id);
      }
    } else {
      setAlertType('warning');
      setAlertMessage('Please select operator');
      setopenAlert(true);
      for (let i = 0; i < tableData.length; i += 1) {
        if (
          tableData[i].Operatorid === undefined ||
          tableData[i].Operatorid === null ||
          Number(tableData[i].Operatorid) === 0
        ) {
          setFieldErrors((prevFieldErrors) => ({
            ...prevFieldErrors,
            [i]: true, // Mark this index (row) as having an error
          }));
          const inputElement = autocompleteRefs.current[i]?.querySelector('input');
          if (inputElement) {
            inputElement.focus();
            break;
          }
        }
      }
    }
  };

  // Modified NewDailyProductiom function
  const NewDailyProductiom = async () => {
    setOpenLoader(true);

    try {
      // Get assigned operator IDs
      const assignedOperatorIds = getAssignedOperatorIds();
      const alreadyassigned = getPreviousAssignedOperatorIds()

      const prevOperatorIds = prevOperator.map((x) => x.Operatorid);

      const operatorsToAssignN = prevOperatorIds.filter(
        (id) => !assignedOperatorIds.includes(id)
      );

      console.log(operatorsToAssignN, 'operatorsToAssignN');

      // Update operators to 'Y' (assigned) and if FinalPr true updtae to N
      if (!FinalPr) {
        if (assignedOperatorIds.length > 0) {
          const updateSuccess = await updateOperatorAssignment(assignedOperatorIds, 'Y');
          await updateOperatorAssignment(operatorsToAssignN, 'N');
          if (!updateSuccess) {
            console.warn('Failed to update some operator assignments');
          }
        }
      } else {
        await updateOperatorAssignment(assignedOperatorIds, 'N');
      }

      return axios.instance
        .post(
          '/InsertDailyProcHeader',
          {
            TsHeaderid: headerData.Tsheaderid,
            DailyProddate: date,
            StyleDescription: headerData.StyleDescription,
            StyleNumber: headerData.StyleNumber,
            GarmentDescription: headerData.GarmentDescription,
            Batchline: headerData.Line_id,
            prhrs: selectedHour,
            CreatedBy: sessionStorage.getItem('UserID'),
            DPcompleted: FinalPr ? 'Y' : 'N',
            CompanyId: sessionStorage.getItem('CompanyId'),
            FiscalYear: sessionStorage.getItem('FiscalYear'),
          },
          {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          }
        )
        .then((headerRes) => {
          if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].DailyProdheaderid !== undefined) {
            const DailyProdheaderid = headerRes.data[0].DailyProdheaderid;

            const finalOperationObjects = tableData.filter((item) => item.finalOperation === 'Y');
            const finalOperationObject = finalOperationObjects[0];
            const finalOperationTargetPcs = finalOperationObject.HoursTarget;
            const finalOperationActualPcs = finalOperationObject.Pieces;

            const detailPromises = tableData.map((obj, index) => {
              const insertData = {
                ...obj,
                DailyProdheaderid,
                Pieces:
                  Number(obj.Pieces) === 0
                    ? Math.round((obj.HoursTarget / finalOperationTargetPcs) * finalOperationActualPcs)
                    : obj.Pieces,
                Dailyno: index + 1,
              };

              return axios.instance.post('/InsertDailydetail', insertData, {
                headers: {
                  Authorization: tokent,
                  'Content-Type': 'application/json',
                },
              });
            });

            return Promise.all(detailPromises)
              .then((detailRes) => {
                setAlertType('success');
                setAlertMessage('Data Added Successfully!');
                setopenAlert(true);
                resetFields();
                setTimeout(() => {
                  setopenAlert(false);
                  setOpenLoader(false);
                  navigate('/dashboard/manage/daily_production');
                }, 2000);
                return detailRes;
              })
              .catch(async (error) => {
                // Rollback operator assignment if detail insertion fails
                // if (assignedOperatorIds.length > 0) {
                //   await updateOperatorAssignment(assignedOperatorIds, 'N');
                // }
                console.error('Error adding detail data:', error);
                setAlertType('error');
                setAlertMessage('Failed to add detail data.');
                setOpenLoader(false);
                setopenAlert(true);
                return Promise.reject(error);
              });
          }
          setAlertType('error');
          setAlertMessage("Oops! Can't add this data...");
          setopenAlert(true);
          setOpenLoader(false);
          return Promise.reject(new Error('Header insert failed'));
        })
        .catch(async (error) => {
          // Rollback operator assignment if header insertion fails
          // if (assignedOperatorIds.length > 0) {
          //   await updateOperatorAssignment(assignedOperatorIds, 'N');
          // }
          console.error('Error adding new Data:', error);
          setAlertType('error');
          setAlertMessage('Failed to add the new Data.');
          setOpenLoader(false);
          setopenAlert(true);
          return Promise.reject(error);
        });
    } catch (error) {
      console.error('Error in NewDailyProductiom:', error);
      setOpenLoader(false);
      return Promise.reject(error);
    }
  };

  // Modified UpdateDailyProductiom function
  const UpdateDailyProductiom = async (id) => {
    setOpenLoader(true);

    try {
      // Get current and previous assigned operator IDs
      const currentAssignedOperatorIds = getAssignedOperatorIds();
      const previousAssignedOperatorIds = getPreviousAssignedOperatorIds();

      // Find operators to assign (new assignments)
      const operatorsToAssign = currentAssignedOperatorIds.filter((id) => !previousAssignedOperatorIds.includes(id));

      // Find operators to unassign (removed assignments)
      const operatorsToUnassign = previousAssignedOperatorIds.filter((id) => !currentAssignedOperatorIds.includes(id));

      // Update operator assignments
      if (!FinalPr) {
        if (operatorsToAssign.length > 0) {
          await updateOperatorAssignment(operatorsToAssign, 'Y');
        }

        if (operatorsToUnassign.length > 0) {
          await updateOperatorAssignment(operatorsToUnassign, 'N');
        }
      } else {
        const combinedClosedOpeartor = currentAssignedOperatorIds.concat(previousAssignedOperatorIds);
        console.log(combinedClosedOpeartor, 'combinedClosedOpeartor');
        await updateOperatorAssignment(combinedClosedOpeartor, 'N');
      }

      return axios.instance
        .put(
          `/updateHeader/${id}`,
          {
            TsHeaderid: headerData.Tsheaderid,
            DailyProddate: date,
            StyleDescription: headerData.StyleDescription,
            StyleNumber: headerData.StyleNumber,
            GarmentDescription: headerData.GarmentDescription,
            Batchline: headerData.Batchline,
            ModifyedBy: sessionStorage.getItem('UserID'),
            DPcompleted: FinalPr ? 'Y' : 'N',
          },
          {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          }
        )
        .then((headerRes) => {
          if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].DailyProdheaderid !== undefined) {
            const DailyProdheaderid = headerRes.data[0].DailyProdheaderid;

            const finalOperationObjects = tableData.filter((item) => item.finalOperation === 'Y');
            const finalOperationObject = finalOperationObjects[0];
            const finalOperationTargetPcs = finalOperationObject.HoursTarget;
            const finalOperationActualPcs = finalOperationObject.Pieces;

            const detailPromises = tableData.map((obj, index) => {
              const insertData = {
                ...obj,
                DailyProdheaderid,
                Pieces:
                  Number(obj.Pieces) === 0
                    ? Math.round((obj.HoursTarget / finalOperationTargetPcs) * finalOperationActualPcs)
                    : obj.Pieces,
                Dailyno: index + 1,
              };

              return axios.instance.post('/InsertDailydetail', insertData, {
                headers: {
                  Authorization: tokent,
                  'Content-Type': 'application/json',
                },
              });
            });

            return Promise.all(detailPromises)
              .then((detailRes) => {
                setAlertType('success');
                setAlertMessage('Data Updated Successfully!');
                setopenAlert(true);
                resetFields();
                setTimeout(() => {
                  setopenAlert(false);
                  setOpenLoader(false);
                  navigate('/dashboard/manage/daily_production');
                }, 2000);
                return detailRes;
              })
              .catch(async (error) => {
                // Rollback operator assignments if detail update fails
                // if (operatorsToAssign.length > 0) {
                //   await updateOperatorAssignment(operatorsToAssign, 'N');
                // }
                // if (operatorsToUnassign.length > 0) {
                //   await updateOperatorAssignment(operatorsToUnassign, 'Y');
                // }
                console.error('Error updating detail data:', error);
                setAlertType('error');
                setAlertMessage('Failed to update detail data.');
                setOpenLoader(false);
                setopenAlert(true);
                return Promise.reject(error);
              });
          }
          setAlertType('error');
          setAlertMessage("Oops! Can't update this data...");
          setopenAlert(true);
          setOpenLoader(false);
          return Promise.reject(new Error('Header update failed'));
        })
        .catch(async (error) => {
          // Rollback operator assignments if header update fails
          // if (operatorsToAssign.length > 0) {
          //   await updateOperatorAssignment(operatorsToAssign, 'N');
          // }
          // if (operatorsToUnassign.length > 0) {
          //   await updateOperatorAssignment(operatorsToUnassign, 'Y');
          // }
          console.error('Error updating Data:', error);
          setAlertType('error');
          setAlertMessage('Failed to update the Data.');
          setOpenLoader(false);
          setopenAlert(true);
          return Promise.reject(error);
        });
    } catch (error) {
      console.error('Error in UpdateDailyProductiom:', error);
      setOpenLoader(false);
      return Promise.reject(error);
    }
  };

  const updateOperatorAssignment = async (operatorIds, isAssigned) => {
    try {
      const updatePromises = operatorIds.map((operatorId) =>
        axios.instance.put(
          `/UpdateUserAssignment/${operatorId}`,
          {
            IsAssigned: isAssigned,
            ModifiedBy: sessionStorage.getItem('UserID'),
          },
          {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          }
        )
      );

      await Promise.all(updatePromises);
      return true;
    } catch (error) {
      console.error('Error updating operator assignment:', error);
      return false;
    }
  };

  const handleCheckboxChange = (operationId) => {
    setSelectedOperations((prevState) =>
      prevState.includes(operationId) ? prevState.filter((id) => id !== operationId) : [...prevState, operationId]
    );
  };

  const searchTermLowerCase = searchTerm.toLowerCase();
  const filteredOperations = OperationData.filter((obj) => {
    // Check if the operation group name matches or if 'All Groups' is selected
    const matchesGroup =
      opGroupSelected.op_group_name === 'All Groups' || obj.op_group_name === opGroupSelected.op_group_name;

    // Filter based on the search term matching any string field in `allRecordsData`
    const matchesSearchTerm = Object.values(obj).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });

    return matchesGroup && matchesSearchTerm;
  });

  const calculateSalaryPerHour = (operatorId, HeaderRetrieveData) => {
    const user = userData.find((user) => Number(user.UserAccessID) === Number(operatorId));

    const workingDays = HeaderRetrieveData?.Weekdays || 26;
    const shiftHoursPerDay = HeaderRetrieveData.shiftHour || 8;

    if (!user) {
      console.error(`User with UserAccessID ${operatorId} not found.`);
      return 0;
    }

    const salary = parseFloat(user.Salary);

    if (isNaN(salary) || salary <= 0) {
      return 0;
    }

    // Calculate the salary per hour
    const salaryPerHour = salary / (workingDays * shiftHoursPerDay);
    return salaryPerHour.toFixed(2);
  };

  const GetoneTs = async (opert) => {
    await axios.instance
      .get(`/GetoneTsDetail/${idState}`, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        const updatedData = res.data.map((item) => ({
          ...item,
          SalaryPerHour_OnDate: calculateSalaryPerHour(item.Operatorid, headerData),
          // SalaryPerHour_OnDate: calculateSalaryPerHour(item.Operatorid),
        }));

        const result = [];
        const arryanew = res.data;

        // In this how many machines are there for each operation in Time & Study
        setFilter(arryanew);

        arryanew.forEach((operation) => {
          for (let i = 0; i < operation.NoofMachines; i++) {
            result.push({ ...operation });
          }
        });

        const operatorCount = {};
        const operatorFirstIndex = {};

        // If there are Two machines for an operation it will ASSIGN THE Operator for the first and the second will be no operator
        result.forEach((item, index) => {
          if (operatorCount[item.Operatorid]) {
            operatorCount[item.Operatorid]++;
          } else {
            operatorCount[item.Operatorid] = 1;
            operatorFirstIndex[item.Operatorid] = index;
          }
        });

        result.forEach((item, index) => {
          if (operatorCount[item.Operatorid] > 1 && index !== operatorFirstIndex[item.Operatorid]) {
            item.Operatorid = 0;
          }
        });

        if (opert.length !== 0) {
          const operatorMap = opert.reduce((map, op) => {
            if (!map[op.Operationid]) {
              map[op.Operationid] = [];
            }
            map[op.Operationid].push(op.Operatorid);
            return map;
          }, {});

          const updatedDetailCollection = result.map((detail) => {
            const operatorIds = operatorMap[detail.Operationid] || [];
            const operatorId = operatorIds.length > 0 ? operatorIds.shift() : detail.Operatorid;

            if (operatorIds.length > 0) {
              operatorMap[detail.Operationid] = operatorIds;
            } else {
              delete operatorMap[detail.Operationid];
            }

            return {
              ...detail,
              Operatorid: operatorId,
            };
          });

          if (removeDuplicates === 'Y') {
            const filteredUserdata = userData.filter(
              (user) => !updatedDetailCollection.some((item) => Number(item.Operatorid) === Number(user.UserAccessID))
            );
            setUserData(filteredUserdata);
          }

          for (const datavalue of updatedDetailCollection) {
            enterdata(datavalue);
          }
        } else {
          if (removeDuplicates === 'Y') {
            const filteredUserdata = userData.filter(
              (user) => !result.some((item) => Number(item.Operatorid) === Number(user.UserAccessID))
            );
            setUserData(filteredUserdata);
          }

          for (const datavalue of result) {
            enterdata(datavalue);
          }
        }
      });
  };

  const enterdata = (data) => {
    const arrays = [...InsertDataDetail]; // Initialize arrays with the current tableData
    const newEntrys = {
      Operationid: data.Operationid,
      Operatorid: data.Operatorid,
      SalaryPerHour_OnDate: calculateSalaryPerHour(data.Operatorid, headerData),
      // SalaryPerHour_OnDate: calculateSalaryPerHour(data.Operatorid),
      OperatorName: data.OperationName,
      Operation: data.OperationName,
      Pieces: 0,
      Headerhours: selectedHour,
      Unit: unitSelected.Unit_Id,
      CreatedBy: sessionStorage.getItem('UserID'),
      Machine_name: data.Machine_name,
      MachineId: data.Mctype,
      finalOperation: id === undefined ? data.FinalOperation : data.finalOperation,
      HoursTarget: data.HoursTarget,
      GradeId: data.GradeId,
    };

    // Update tableData state
    setTableData((prevTableData) => [...prevTableData, newEntrys]);

    const newEntry = {
      Operationid: data.Operationid,
      Operatorid: data.Operatorid,
      SalaryPerHour_OnDate: calculateSalaryPerHour(data.Operatorid, headerData),
      // SalaryPerHour_OnDate: calculateSalaryPerHour(data.Operatorid),
      OperatorName: data.OperationName,
      Operation: data.OperationName,
      Pieces: 0,
      Headerhours: selectedHour,
      Unit: unitSelected.Unit_Id,
      CreatedBy: sessionStorage.getItem('UserID'),
      Machine_name: data.Machine_name,
      MachineId: data.Mctype,
      finalOperation: id === undefined ? data.FinalOperation : data.finalOperation,
      HoursTarget: data.HoursTarget,
      GradeId: data.GradeId,
    };

    setInsertDataDetail((prevInsertDataDetail) => [...prevInsertDataDetail, newEntry]);

    arrays.push(newEntry);

    const filterdatas = OperationDataOption.filter(
      (obj) => !arrays.some((obj1) => obj1.Operationid === obj.Operationid)
    );
    setOperationDataOption(filterdatas);

    resetFields();
  };

  const addDailyProduction = () => {
    const GetPrevDetails = async () => {
      try {
        const res = await axios.instance.get(`GetPrevDailydetail/${obSelected.Tsheaderid}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        const datas = res.data;
        console.log(datas, 'datas');
        GetoneTs(datas);
        handleExpansion();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    const getCurrentDaily = async () => {
      try {
        const res = await axios.instance.get(`GetoneDailydetail/${dailyMaxId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        setprevOperator(res.data);
        const updatedData = res.data.map((item) => ({
          ...item,
          Pieces: 0,
          Headerhours: selectedHour,
          SalaryPerHour_OnDate:
            item.SalaryPerHour_OnDate === 0
              ? calculateSalaryPerHour(item.Operatorid, headerData)
              : item.SalaryPerHour_OnDate,
          // item.SalaryPerHour_OnDate === 0 ? calculateSalaryPerHour(item.Operatorid) : item.SalaryPerHour_OnDate,
        }));
        setTableData(updatedData);
        // console.log(updatedData, 'updatedData2')
        // setOriginalTableData(updatedData);
        setInsertDataDetail(updatedData);
        const datas = updatedData;
        // GetAllUser(datas);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    if (HoursData.filter((data) => data.prhrs === 'H12').length === 0) {
      if (dailyMaxId === 0) {
        GetPrevDetails();
      } else {
        // Added by Harel on 11-09-2024 to load the previous hour data
        getCurrentDaily();
      }
    } else {
      // toastr.error("alread done for this hours", `${selectedHour}`)
      alert(`already done for this hours`);
      // toastr.info('Are you the 6 fingered man?')
    }
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setOpGroupSelected({ op_group_name: 'All Groups' });
  };

  function handleDetailChange(index, field, value) {
    const updatedDetails = [...tableData];
    updatedDetails[index][field] = value;
    setTableData(updatedDetails);

    if (field === 'SalaryPerHour_OnDate') {
      const workingDays = headerData.Weekdays || 26;
      const shiftHoursPerDay = headerData.ShiftHour || 8;
      const salaryPerHour = value / (workingDays * shiftHoursPerDay);
      updatedDetails[index][field] = salaryPerHour.toFixed(2);
    }

    if (field === 'Operatorid') {
      if (removeDuplicates === 'Y') {
        const filtersedUserdata = AllUsersData.filter(
          (user) => !updatedDetails.some((item) => Number(item.Operatorid) === Number(user.UserAccessID))
        );
        setUserData(filtersedUserdata);
      }
    }

    const updatedDetails1 = [...InsertDataDetail];
    updatedDetails[index][field] = value;
    setInsertDataDetail(updatedDetails1);
  }

  const handlePieceCalculate = (index, field, value) => {
    const updatedDetails = [...tableData];
    updatedDetails[index][field] = value;
    setTableData(updatedDetails); // Update the tableData state with the updated details  

    if (
      field === 'Pieces' &&
      updatedDetails[index]?.finalOperation === 'Y'
    ) {
      const finalTarget = Number(updatedDetails[index].HoursTarget || 0);
      const finalActual = Number(value || 0);

      if (finalTarget > 0 && finalActual > 0) {
        updatedDetails.forEach((row, i) => {
          if (row.finalOperation !== 'Y') {
            updatedDetails[i].Pieces = Math.round(
              (Number(row.HoursTarget || 0) / finalTarget) * finalActual
            );
          }
        });
      }
    }
    setTableData(updatedDetails);

  };

  function handleSalaryPerHour(index, field, value) {
    const updatedDetails = [...tableData];
    const workingDays = headerData.Weekdays || 26;
    const shiftHoursPerDay = headerData.ShiftHour || 8;
    const salaryPerHour = value / (workingDays * shiftHoursPerDay);
    updatedDetails[index][field] = salaryPerHour.toFixed(2);
    const updatedDetails1 = [...InsertDataDetail];
    setTableData(updatedDetails);
    setInsertDataDetail(updatedDetails1);
  }

  const handleFromDateChange = (event) => {
    const inputDate = event.target.value;
    const dateObj = new Date(inputDate);
    const today = new Date().toISOString().split('T')[0];

    // Check for invalid date
    // if (isNaN(dateObj.getTime()) || inputDate !== dateObj.toISOString().slice(0, 10)) {
    if(inputDate > today)
    {
      setAlertType('error');
      setAlertMessage('Future dates are not allowed! Please select today or a past date.');
      setopenAlert(true);
      return;
    }

    if (obSelected) Gethours(obSelected.Tsheaderid, inputDate);
    setDate(inputDate); // Safe to set
  };

  const handleChange = (event) => {
    setSelectedHour(event.target.value);
  };

  const GetallTNS = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(
        `/GetallTNS/${sessionStorage.getItem('CompanyId')}/${sessionStorage.getItem('factoryID')}`,
        {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        }
      );

      const uniqueProducts = [];
      const TsNoNoSet = new Set();

      res.data.forEach((product) => {
        if (!TsNoNoSet.has(product.TsNo)) {
          TsNoNoSet.add(product.TsNo);
          uniqueProducts.push({ ...product });
        }
      });

      setallRecordsData(uniqueProducts);

      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const GetOperationBasedTNA = async (ids) => {
    setOpenLoader(true);
    setTNAid(ids);
    try {
      const res = await axios.instance.get(`GetOperationBasedTNA/${ids}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationDataOption(res.data);
      setOpenLoader(false);
      if (id) {
        getonedetails(res.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleAddOperations = () => {
    const newAddedOperations = OperationData.filter((operation) => selectedOperations.includes(operation.OperationId));

    const newOperationDetails = newAddedOperations.map((operation) => {
      const selectedMachineObj = machineData.find((obj) => obj.Machine_Id === operation.Machine_Id);
      return {
        Operationid: operation.OperationId,
        Operatorid: 0,
        OperatorName: operation.OperationName,
        Operation: operation.OperationName,
        Pieces: 0,
        Headerhours: selectedHour,
        Unit: unitSelected.Unit_Id,
        CreatedBy: sessionStorage.getItem('UserID'),
        Machine_name: operation.Machine_name,
        MachineId: selectedMachineObj ? selectedMachineObj.Machine_Id : null,
        finalOperation: 'N',
        HoursTarget: 0,
      };
    });

    setTableData((prevState) => {
      // Clone the existing state
      const updatedTableData = [...prevState];

      // Insert each new operation after the last matching operation
      newOperationDetails.forEach((newOp) => {
        // Find the index of the last matching operation
        let lastMatchingIndex = -1;
        for (let i = 0; i < updatedTableData.length; i++) {
          if (updatedTableData[i].Operationid === newOp.Operationid) {
            lastMatchingIndex = i;
          }
        }

        // Insert the new operation after the last matching operation
        if (lastMatchingIndex !== -1) {
          updatedTableData.splice(lastMatchingIndex + 1, 0, newOp);
        } else {
          // If no match is found, add the new operation to the end
          updatedTableData.push(newOp);
        }
      });

      return updatedTableData;
    });
    // setSelectedOperations([]);
    setRepeatOperation({ OperationName: '', Operationid: 0 });
    setDialogOpen(false);
  };

  const handleAddRowOperations = (index, operation) => {
    const updatedData = [...tableData];

    const newOperationDetails = {
      Operationid: operation.Operationid,
      Operatorid: 0,
      OperatorName: operation.OperationName,
      Operation: operation.Operation,
      Pieces: 0,
      Headerhours: operation.Headerhours,
      Unit: operation.Unit,
      CreatedBy: operation.CreatedBy,
      Machine_name: operation.Machine_name,
      MachineId: operation.MachineId,
      finalOperation: operation.finalOperation,
      HoursTarget: operation.HoursTarget,
    };

    updatedData.splice(index + 1, 0, newOperationDetails);
    setTableData(updatedData);
  };

  const [selectedOperatorsMap, setSelectedOperatorsMap] = useState([]);
  const [loadAllEmployees, setLoadAllEmployees] = useState({});
  // Add this useEffect to initialize selected operators in edit mode
  useEffect(() => {
    if (id && tableData.length > 0) {
      // Initialize selectedOperatorsMap with operators from tableData
      const initialSelectedOperators = tableData
        .filter((obj) => obj.Operatorid != null)
        .map((obj) => {
          // Find the operator details from AllUsersData
          const operator =
            AllUsersData.find((user) => Number(user.UserAccessID) === Number(obj.Operatorid)) ||
            userData.find((user) => Number(user.UserAccessID) === Number(obj.Operatorid));

          return operator
            ? {
              operatorId: operator.UserAccessID,
              lineId: operator.LineId,
            }
            : null;
        })
        .filter(Boolean); // Remove null values

      setSelectedOperatorsMap(initialSelectedOperators);
    }
  }, [id, tableData, AllUsersData, userData]);

  const GetAllUser = async (LineId) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllUsers/N', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });

      // Filter users not equal to 'N/A'
     //  const allUsers = res.data.filter((item) => item.GradeName !== 'N/A' && item.ActiveStatus === 'Y');
           
      const allUsers = res.data.filter((item) => item.GradeName !== 'N/A' && item.LineName !== 'NA' && item.ActiveStatus === 'Y');

      // Set AllUsersData with all users
      setAllUsersData(allUsers);

      let filteredUsers;
      if (id) {
        // EDIT MODE: Filter by line and exclude already assigned operators from THIS record
        const assignedOperatorIds = tableData.map((obj) => obj.Operatorid).filter((id) => id != null);

        filteredUsers = allUsers.filter(
          (user) => user.LineId === LineId && !assignedOperatorIds.includes(user.UserAccessID)
        );
      } else {
        // NEW MODE: Filter by line and exclude operators already assigned in ANY form
        // But DO NOT exclude operators that are in current tableData (they'll be filtered in getFilteredUserData)
        filteredUsers = allUsers.filter((user) => user.LineId === LineId && user.IsAssigned === 'N');
        // filteredUsers = allUsers.filter((user) => user.LineId === LineId);

      }

      setUserData(filteredUsers);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  const handleDeleteOperation = useCallback(
    async (index) => {
      const deletedOperation = tableData[index];
      const deletedOperatorId = deletedOperation?.Operatorid;

      // First, update the tableData state
      setTableData((prevDetails) => {
        const updatedTableData = prevDetails.filter((_, i) => i !== index);
        return updatedTableData;
      });

      // Remove the item from insertDataDetail state
      setInsertDataDetail((prevDetails) => prevDetails.filter((_, i) => i !== index));

      // Remove the operator from selected operators map
      if (deletedOperatorId) {
        setSelectedOperatorsMap((prev) => prev.filter((operator) => operator.operatorId !== deletedOperatorId));

        // Add the deleted operator back to available userData if they belong to current line
        const deletedOperator = AllUsersData.find((user) => user.UserAccessID === deletedOperatorId);
        if (deletedOperator && deletedOperator.LineId === headerData?.Line_id) {
          setUserData((prevUserData) => {
            const alreadyExists = prevUserData.some((user) => user.UserAccessID === deletedOperatorId);
            if (!alreadyExists) {
              return [...prevUserData, deletedOperator];
            }
            return prevUserData;
          });
        }
      }

      // Remove the loadAllEmployees state for this index
      setLoadAllEmployees((prev) => {
        const newState = { ...prev };
        delete newState[index];
        return newState;
      });

      // Define an asynchronous function to fetch additional data
      const getAllData = async () => {
        try {
          const res = await axios.instance.get(`GetOperationBasedTNA/${TNAid}`, {
            headers: { Authorization: tokent, 'Content-Type': 'application/json' },
          });
          const data = res.data;

          // Get the removed entry based on the index
          const removedEntry = tableData[index];

          // Filter the fetched data based on the removed entry
          const filteredData = data.filter((obj) => obj.OperationName === removedEntry.Operation);

          // Update operation data option with the filtered data
          setOperationDataOption((prevOption) => [...prevOption, ...filteredData]);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };

      getAllData();
    },
    [tableData, AllUsersData, headerData, TNAid, tokent]
  );


  const handleLoadAllEmployeesToggle = (index) => {
    setLoadAllEmployees(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // const handleLoadAllEmployeesToggle = (index) => {
  //   setLoadAllEmployees((prev) => ({
  //     ...prev,
  //     [index]: !prev[index],
  //   }));
  // };

  // Add grade label function
  // const getGradeLabel = (gradeId) => {
  //   const gradeMap = {
  //     1: 'A+',
  //     2: 'A',
  //     3: 'B',
  //     4: 'C',
  //     5: 'D',
  //     6: 'N/A',
  //     7: 'Trainee',
  //   };
  //   return gradeData[gradeId] || 'Unknown';
  // };

  // gradeData = [{ GradeValue: "1", GradeLable: "A+" }, ... ]

  const getGradeLabel = (gradeId) => {
    if (!gradeData || gradeData.length === 0) return 'Unknown';

    const found = gradeData.find((item) => item.Grade == gradeId);
    return found ? found.GradeLable : 'Unknown';
  };


  const getFilteredUserData = (index) => {
    const currentOperationGrade = tableData[index]?.GradeId;
    const currentOperationOperatorId = tableData[index]?.Operatorid;
    const currentLineId = headerData?.Line_id;


    if (dupEmpinDailyProd) {

      const userPool = loadAllEmployees[index] ? AllUsersData : userData;

      // Still apply Assigned + Grade rules
      let filteredUsers = userPool.filter((user) => {
        if (!id && user.IsAssigned === 'Y') return false;
        return true;
      });

      if (currentOperationGrade) {
        filteredUsers = filteredUsers
          .filter((user) => Number(user.Grade) <= Number(currentOperationGrade))
          .sort((a, b) => {
            const aExact = a.Grade === currentOperationGrade;
            const bExact = b.Grade === currentOperationGrade;

            if (aExact && !bExact) return -1;
            if (!aExact && bExact) return 1;
            return b.Grade - a.Grade;
          });
      }

      return filteredUsers;
    }


    // Get all operator IDs from OTHER operations only (excluding current operation)
    const allSelectedOperatorIds = new Set();

    // Add operators from selectedOperatorsMap (only from current line)
    selectedOperatorsMap.forEach((operator) => {
      // Only add operators that are NOT from the current operation AND from the current line
      if (
        Number(operator.operatorId) !== Number(currentOperationOperatorId) &&
        Number(operator.lineId) === Number(currentLineId)
      ) {
        allSelectedOperatorIds.add(operator.operatorId);
      }
    });

    // Add operators from tableData (from ALL lines - both current and other lines)
    tableData.forEach((obj, idx) => {
      if (idx !== index && obj.Operatorid != null) {
        // Only add operators that are NOT from the current operation
        // Include operators from ALL lines in tableData
        if (Number(obj.Operatorid) !== Number(currentOperationOperatorId)) {
          allSelectedOperatorIds.add(obj.Operatorid);
        }
      }
    });

    let userPool;
    if (loadAllEmployees[index]) {
      // Use all users from initial data
      userPool = AllUsersData;
    } else {
      // Use line-specific users
      userPool = userData;
    }

    // let userPool;
    // if (loadAllEmployees[index]) {
    //   // Use all users from initial data
    //   userPool = AllUsersData;
    // } else {
    //   // Use line-specific users
    //   userPool = userData;
    // }


    // Filter out operators selected in other rows (from ALL lines in tableData)
    let filteredUsers = userPool.filter((user) => {

      // Exclude operators that are in tableData (regardless of their line)
      if (allSelectedOperatorIds.has(Number(user.UserAccessID))) {
        return false;
      }

      // In new mode, also exclude operators assigned in other forms
      if (!id && user.IsAssigned === 'Y') {
        return false;
      }

      return true;
    });

    // console.log(tableData[index].Operation , filteredUsers, 'filteredUsers before grade filter');

    if (currentOperationGrade) {
      filteredUsers = filteredUsers.filter((user) => Number(user.Grade) <= Number(currentOperationGrade));

      // Sort: first by whether grade matches current operation grade, then by grade descending
      filteredUsers = filteredUsers.sort((a, b) => {
        // Priority 1: Operators with exact grade match come first
        const aIsExactMatch = a.Grade === currentOperationGrade;
        const bIsExactMatch = b.Grade === currentOperationGrade;

        if (aIsExactMatch && !bIsExactMatch) return -1;
        if (!aIsExactMatch && bIsExactMatch) return 1;

        // Priority 2: Then sort by grade in descending order
        return b.Grade - a.Grade;
      });
    }
    // console.log(tableData[index].Operation , filteredUsers, 'filteredUsers after grade filter')
    return filteredUsers;
  };

  // const handleInputChangeUserSelect = (index, newValue) => {
  //   const currentOperationGrade = tableData[index]?.GradeId;
  //   const currentRow = tableData[index];
  //   const previousOperatorId = currentRow?.Operatorid; // Get from current tableData

  //   // Grade validation (only when checkbox is not checked)
  //   if (newValue && !loadAllEmployees[index] && currentOperationGrade && newValue.GradeId > currentOperationGrade) {
  //     alert(
  //       `This operator (Grade: ${getGradeLabel(
  //         newValue.GradeId
  //       )}) cannot be assigned to this operation (Grade: ${getGradeLabel(currentOperationGrade)})`
  //     );
  //     return;
  //   }

  //   // Assignment status validation for new mode
  //   if (!id && newValue && newValue.IsAssigned === 'Y') {
  //     alert('This operator is already assigned to another operation in different form');
  //     return;
  //   }

  //   // Check for duplicate operator selection (excluding current operation's previous operator)
  //   const exists = selectedOperatorsMap.some(
  //     (operator) =>
  //       Number(operator.operatorId) === Number(newValue?.UserAccessID) &&
  //       Number(operator.operatorId) !== Number(previousOperatorId)
  //   );

  //   if (exists && removeDuplicates === 'Y') {
  //     alert('Operator Already Selected in current form');
  //     return;
  //   }

  //   // Update selected operators map IMMEDIATELY
  //   setSelectedOperatorsMap((prev) => {
  //     let updatedMap = [...prev];

  //     // Remove previous operator if exists
  //     if (previousOperatorId) {
  //       const beforeRemove = updatedMap.length;
  //       updatedMap = updatedMap.filter((op) => Number(op.operatorId) !== Number(previousOperatorId));
  //     }

  //     // Add new operator if selected and not already present
  //     if (newValue) {
  //       const alreadyExists = updatedMap.some((op) => Number(op.operatorId) === Number(newValue.UserAccessID));
  //       updatedMap.push({
  //         operatorId: newValue.UserAccessID,
  //         lineId: newValue.LineId,
  //       });
  //     }
  //     return updatedMap;
  //   });

  //   // Update table data AFTER updating the map
  //   handleDetailChange(index, 'Operatorid', newValue ? Number(newValue.UserAccessID) : null);

  //   if (newValue) {
  //     handleSalaryPerHour(index, 'SalaryPerHour_OnDate', Number(newValue.Salary));
  //   } else {
  //     handleSalaryPerHour(index, 'SalaryPerHour_OnDate', null);
  //   }

  //   setFieldErrors((prevFieldErrors) => ({
  //     ...prevFieldErrors,
  //     [index]: !newValue,
  //   }));
  // };

  const handleInputChangeUserSelect = (index, newValue) => {
    const currentOperationGrade = tableData[index]?.GradeId;
    const currentRow = tableData[index];
    const previousOperatorId = currentRow?.Operatorid;

    // Grade validation (only when checkbox is not checked)
    if (newValue && !loadAllEmployees[index] && currentOperationGrade && newValue.GradeId > currentOperationGrade) {
      alert(
        `This operator (Grade: ${getGradeLabel(
          newValue.GradeId
        )}) cannot be assigned to this operation (Grade: ${getGradeLabel(currentOperationGrade)})`
      );
      return;
    }

    // Assignment status validation for new mode
    if (!id && newValue && newValue.IsAssigned === 'Y') {
      alert('This operator is already assigned to another operation in different form');
      return;
    }

    // Check for duplicate operator selection (excluding current operation's previous operator)
    const exists = selectedOperatorsMap.some(
      (operator) =>
        Number(operator.operatorId) === Number(newValue?.UserAccessID) &&
        Number(operator.operatorId) !== Number(previousOperatorId)
    );

    if (exists && removeDuplicates === 'Y') {
      alert('Operator Already Selected in current form');
      return;
    }

    // Update selected operators map
    setSelectedOperatorsMap((prev) => {
      let updatedMap = [...prev];

      // Remove previous operator if exists
      if (previousOperatorId) {
        updatedMap = updatedMap.filter((op) => Number(op.operatorId) !== Number(previousOperatorId));
      }

      // Add new operator if selected
      if (newValue) {
        // First remove if already exists (to avoid duplicates)
        updatedMap = updatedMap.filter((op) => Number(op.operatorId) !== Number(newValue.UserAccessID));

        updatedMap.push({
          operatorId: newValue.UserAccessID,
          lineId: newValue.LineId,
        });
      }

      return updatedMap;
    });

    // If operator is being removed (set to null), add the previous operator back to userData
    if (!newValue && previousOperatorId) {
      const previousOperator = AllUsersData.find((user) => user.UserAccessID === previousOperatorId);

      if (previousOperator) {
        // Check if the previous operator belongs to the current line or if we're showing all employees
        const shouldAddBack = loadAllEmployees[index] || previousOperator.LineId === headerData?.Line_id;

        if (shouldAddBack) {
          setUserData((prevUserData) => {
            const alreadyExists = prevUserData.some((user) => user.UserAccessID === previousOperatorId);
            if (!alreadyExists) {
              return [...prevUserData, previousOperator];
            }
            return prevUserData;
          });
        }
      }
    }

    // Update table data AFTER updating the map
    handleDetailChange(index, 'Operatorid', newValue ? Number(newValue.UserAccessID) : null);

    if (newValue) {
      handleSalaryPerHour(index, 'SalaryPerHour_OnDate', Number(newValue.Salary));
    } else {
      handleSalaryPerHour(index, 'SalaryPerHour_OnDate', null);
    }

    setFieldErrors((prevFieldErrors) => ({
      ...prevFieldErrors,
      [index]: !newValue,
    }));
  }; const handleSetQtyToZeroChange = (checked) => {
    if (checked) {
      // Show confirmation alert before proceeding
      const userConfirmed = window.confirm(
        'Warning: Once you check this, all pieces will be set to 0 and this action cannot be undone. Do you want to continue?'
      );

      if (userConfirmed) {
        setSetPiecesToZero(true);
        // Update tableData immediately when checkbox is checked
        const updatedTableData = tableData.map((item) => ({
          ...item,
          Pieces: 0,
        }));
        setTableData(updatedTableData);

        // Optional: Show a success message
        alert('All pieces have been set to 0. This action cannot be reversed.');
      }
      // If user cancels, checkbox remains unchecked
    } else {
      setSetPiecesToZero(false);
    }
  };

  return (
    <>
      <Snackbar
        key={alertMessage}
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
        >
          <Box>
            <Link to={'/dashboard/manage/daily_production'}>
              <Button variant="outlined" color="info" startIcon={<KeyboardBackspaceIcon />}>
                Back
              </Button>
            </Link>
          </Box>
          <Typography
            variant="h5"
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={1}
            pl={2}
            pr={1}
            color="white"
            sx={{
              borderTopLeftRadius: 50,
              borderBottomLeftRadius: 50,
              background: 'linear-gradient(to right, #314755, #26a0da);',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={2} sx={{ p: 0 }}>
              <KeyboardDoubleArrowLeftIcon />
              <Typography variant="body2" color="white" className="font_style1">
                Daily Production
              </Typography>
            </Stack>
          </Typography>
        </Stack>
        <Paper elevation={5} sx={{ my: 2, py: 1, background: 'initial' }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              {/* <Typography variant="h6" color="#607d8b" textAlign={'left'} mx={2}>
                Time & Study Details
              </Typography> */}
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Divider sx={{ mb: 2 }} />
              <Box sx={{ width: '100%', mt: 1 }}>
                <form onSubmit={handleFormSubmit}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item md={4} xs={12}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          disabled={id !== undefined}
                          options={allRecordsData}
                          isClearable
                          getOptionLabel={(obj) => (obj ? `${obj.TsNo} - ${obj.StyleDescription} - ${obj.StyleNumber}-${obj.Line_Name} ` : '')}
                          isOptionEqualToValue={
                            ((option, value) => option?.Tsheaderid === value?.Tsheaderid) ?? undefined
                          }
                          renderInput={(params) => <TextField {...params} label="Select Styles" />}
                          value={obSelected}
                          onChange={(e, newValue) => {
                            if (tableData.length === 0) {
                              setObSelected(newValue);
                              Gethours(newValue.Tsheaderid, date);
                              setIdState(newValue.Tsheaderid);
                            } else {
                              setOpenDelete(true);
                              setTSValue(newValue);
                            }

                            setFieldErrors((prevFieldErrors) => ({
                              ...prevFieldErrors,
                              obSelected: !newValue,
                            }));
                          }}
                        />
                        {fieldErrors.obSelected && (
                          <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                            please select time and study record
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          // disabled={id !== undefined || tableData.length !== 0}
                          disabled
                          options={unitData}
                          getOptionLabel={(obj) => (obj ? obj.Unit_Name : '')}
                          isOptionEqualToValue={((option, value) => option?.Unit_Id === value?.Unit_Id) ?? undefined}
                          renderInput={(params) => <TextField {...params} label="Factory Unit" />}
                          value={unitSelected}
                          onChange={(e, newValue) => {
                            setUnitSelected(newValue);
                            setFieldErrors((prevFieldErrors) => ({
                              ...prevFieldErrors,
                              unitSelected: !newValue,
                            }));
                          }}
                        />
                        {fieldErrors.unitSelected && (
                          <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                            Please select production unit
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <TextField
                          fullWidth
                          size="small"
                          label="DP Date"
                          disabled={id || tableData.length !== 0}
                          type="date"
                          value={date}
                          onChange={handleFromDateChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <Grid container alignItems="left">
                        {daywiseEntry && (
                          <Grid item xs={3}>
                            <Checkbox
                              checked={hourChecked}
                              onChange={handleCheckChange}
                              inputProps={{ 'aria-label': 'controlled' }}
                              disabled={id}
                            />
                          </Grid>
                        )}
                        <Grid item xs={daywiseEntry ? 9 : 11}>
                          <FormControl size="small" fullWidth>
                            <InputLabel id="demo-select-small-label">Hour</InputLabel>
                            <Select
                              disabled={!hourChecked}
                              labelId="demo-select-small-label"
                              id="demo-select-small"
                              value={selectedHour}
                              label="Hour"
                              onChange={handleChange}
                            >
                              <MenuItem value={'H1'}>Hour 1</MenuItem>
                              <MenuItem value={'H2'}>Hour 2</MenuItem>
                              <MenuItem value={'H3'}>Hour 3</MenuItem>
                              <MenuItem value={'H4'}>Hour 4</MenuItem>
                              <MenuItem value={'H5'}>Hour 5</MenuItem>
                              <MenuItem value={'H6'}>Hour 6</MenuItem>
                              <MenuItem value={'H7'}>Hour 7</MenuItem>
                              <MenuItem value={'H8'}>Hour 8</MenuItem>
                              <MenuItem value={'H9'}>Hour 9</MenuItem>
                              <MenuItem value={'H10'}>Hour 10</MenuItem>
                              <MenuItem value={'H11'}>Hour 11</MenuItem>
                              <MenuItem value={'H12'}>Hour 12</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>

                    {id === undefined && (
                      <Grid item md={1} xs={12}>
                        <Button
                          variant="contained"
                          color="warning"
                          disabled={tableData.length !== 0}
                          onClick={() => {
                            if (!obSelected) {
                              setAlertType('warning');
                              setAlertMessage('Please select Style');
                              setopenAlert(true);
                            }
                            else {
                              addDailyProduction()
                            }
                          }}
                          fullWidth
                        >
                          Add
                        </Button>
                      </Grid>
                    )}
                    {obSelected === null && (
                      <Stack
                        direction={'row'}
                        sx={{ width: '100%' }}
                        justifyContent={'center'}
                        alignItems={'center'}
                        spacing={2}
                      >
                        <img
                          src={noimge}
                          style={{ objectFit: 'contain', maxWidth: '30%', mixBlendMode: 'multiply' }}
                          alt="ob logo"
                        />
                      </Stack>
                    )}
                  </Grid>
                </form>
              </Box>

              {obSelected !== null && (
                <>
                  <Divider sx={{ mt: 2 }} />
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item md={12}>
                      <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        p={2}
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              TS Reference :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {headerData?.TsNo}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              Style Description :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {headerData?.StyleDescription}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              Style Number :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688" textTransform={'capitalize'}>
                              {headerData?.StyleNumber}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" sx={{ whiteSpace: 'nowrap' }} pr={1}>
                              Batch or Line :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {headerData?.Line_Name}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" sx={{ whiteSpace: 'nowrap' }} pr={1}>
                              Hours :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {HoursData.map((data) => data.prhrs).join(', ')}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" sx={{ whiteSpace: 'nowrap' }} pr={1}>
                              Remarks :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {headerData?.remarks}
                            </Typography>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
            </AccordionDetails>
          </Accordion>
        </Paper>

        {obSelected !== null && (
          <>
            <Stack
              justifyContent={'space-between'}
              alignItems={'center'}
              direction={'row'}
              spacing={2}
              fullWidth
              mb={2}
            >
              <Button variant="outlined" color="primary" onClick={handleDialogOpen} disabled={isLastProduction}>
                Add Operations
              </Button>

              <Stack direction="row" spacing={2} alignItems="center">
                <div>
                  Mark as Closed
                  <Checkbox
                    checked={FinalPr}
                    disabled={isDisabled}
                    onChange={() => {
                      setFinalPr(!FinalPr);
                    }}
                  />
                </div>

                <div>
                  Set Pieces to 0
                  <Checkbox
                    checked={setPiecesToZero} // You'll need to define this state
                    disabled={isDisabled || setPiecesToZero} // or use a different disabled condition
                    onChange={(e) => handleSetQtyToZeroChange(e.target.checked)}
                  />
                </div>
              </Stack>
            </Stack>
            <TableContainer
              component={Paper}
              elevation={5}
              sx={{
                maxHeight: 600,
                borderRadius: 1,
                backgroundColor: 'inherit',
              }}
            >
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableHeader align="center">S.No</StyledTableHeader>
                    <StyledTableHeader align="left">Operation</StyledTableHeader>
                    <StyledTableHeader align="left">Machine</StyledTableHeader>
                    <StyledTableHeader align="center">Operator</StyledTableHeader>
                    <StyledTableHeader align="center">Target/Hour</StyledTableHeader>
                    <StyledTableHeader align="center">Pieces</StyledTableHeader>
                    <StyledTableHeader align="center">Hour</StyledTableHeader>
                    <StyledTableHeader align="center">Actions</StyledTableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map((obj, index) => (
                    <TableRow
                      key={index}
                      hover
                      sx={{
                        backgroundColor: obj.finalOperation === 'Y' ? '#D6EFD8' : 'inherit',
                      }}
                    >
                      <StyledTableCell align="center">{index + 1}</StyledTableCell>
                      <StyledTableCell
                        align="left"
                        sx={{ textTransform: 'capitalize' }}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        {obj.Operation}
                        <br />
                        <Chip
                          label={`Grade: ${getGradeLabel(obj.GradeId)}`}
                          size="small"
                          variant="outlined"
                          sx={{ fontSize: '0.6rem', height: '20px', mt: 0.5 }}
                        />
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        sx={{ textTransform: 'capitalize' }}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        {obj.Machine_name}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        sx={{ textTransform: 'capitalize', minWidth: '350px' }}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Autocomplete
                            key={index}
                            size="small"
                            fullWidth
                            options={getFilteredUserData(index)}
                            getOptionLabel={(user) =>
                              user
                                ? `${user.UserName} (Grade: ${getGradeLabel(user.GradeId)}) - ${user.IsAssigned === 'Y' ? 'Assigned' : 'Available'
                                }`
                                : ''
                            }
                            isOptionEqualToValue={(option, value) => option?.UserAccessID === value?.UserAccessID}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Operator"
                                InputProps={{
                                  ...params.InputProps,
                                  style: { fontSize: '14px' },
                                }}
                                InputLabelProps={{
                                  style: { fontSize: '14px' },
                                }}
                                error={!!fieldErrors[index]}
                                helperText={fieldErrors[index] ? 'Operator selection required' : ''}
                              />
                            )}
                            disableClearable
                            disabled={isLastProduction}
                            // value={
                            //   AllUsersData.find(user => Number(user.UserAccessID) === Number(tableData[index].Operatorid)) || null
                            // }
                            value={(() => {
                              const selectedOperatorId = Number(tableData[index].Operatorid);
                              const foundUser = AllUsersData.find(
                                (user) => Number(user.UserAccessID) === selectedOperatorId
                              );

                              if (!foundUser) {
                                return null;
                              }

                              const isValid =
                                foundUser.Tsheaderid === 0 ||
                                foundUser.Tsheaderid === '0' ||
                                (headerData?.Tsheaderid &&
                                  Number(foundUser.Tsheaderid) === Number(headerData.Tsheaderid)) ||
                                !headerData?.Tsheaderid;

                              return isValid ? foundUser : null;
                            })()}
                            onChange={(e, newValue) => {
                              handleInputChangeUserSelect(index, newValue);
                            }}
                            renderOption={(props, user) => (
                              <li
                                {...props}
                                style={{
                                  backgroundColor: user.IsAssigned === 'Y' ? '#fff3cd' : 'white',
                                  fontWeight: user.IsAssigned === 'Y' ? 'bold' : 'normal',
                                }}
                              >
                                {`${user.UserName} (Grade: ${getGradeLabel(user.Grade)}) - ${user.IsAssigned === 'Y' ? 'Assigned' : 'Available'
                                  }`}
                              </li>
                            )}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                size="small"
                                checked={loadAllEmployees[index] || false}
                                onChange={() => handleLoadAllEmployeesToggle(index)}
                                color="primary"
                              />
                            }
                            label="Show all available operators (ignore line restriction)"
                            sx={{
                              m: 0,
                              '& .MuiFormControlLabel-label': {
                                fontSize: '0.75rem',
                              },
                            }}
                          />
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={{ textTransform: 'capitalize' }}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        {obj.HoursTarget}
                      </StyledTableCell>
                      <StyledTableCell align="center" sx={{ minWidth: '75px', maxWidth: '100px', padding: '4px' }}>
                        <TextField
                          id={`Pieces${index}`}
                          size="small"
                          sx={{
                            width: '100%',
                            maxWidth: '65px',
                            '& .MuiOutlinedInput-root': {
                              '& input': {
                                padding: '6px 8px',
                                textAlign: 'center',
                              },
                              '& fieldset': {
                                borderColor: obj.Pieces === 0 || obj.Pieces === '' ? 'red' : 'rgba(0, 0, 0, 0.23)',
                              },
                              '&:hover fieldset': {
                                borderColor: obj.Pieces === 0 || obj.Pieces === '' ? 'red' : 'black',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: obj.Pieces === 0 || obj.Pieces === '' ? 'red' : '#3f51b5',
                              },
                            },
                          }}
                          type="number"
                          onFocus={(e) => {
                            e.target.select();
                          }}
                          InputProps={{
                            style: { fontSize: '14px' },
                            borderColor: obj.Pieces === 0 || obj.Pieces === '' ? 'red' : undefined,
                          }}
                          InputLabelProps={{
                            style: { fontSize: '14px' },
                          }}
                          value={obj.Pieces}
                          onChange={(e) => {
                            handleDetailChange(index, 'Pieces', e.target.value);

                            // setTableData((prev) =>
                            //   prev.map((row, i) => {
                            //     if (i !== index) {
                            //       return { ...row, Pieces: 0 };
                            //     }
                            //     return row;
                            //   })
                            // );
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();

                              // ✅ Trigger calculation ONLY on Enter
                              handlePieceCalculate(index, 'Pieces', Number(e.target.value));
                            }
                          }}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter' && index + 1 <= tableData.length - 1) {
                              document.getElementById(`Pieces${index + 1}`).focus();
                            }
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ maxWidth: '100px' }}>
                        {obj.Headerhours}
                      </StyledTableCell>
                      <StyledTableCell align="center" sx={{ padding: '0' }}>
                        <Tooltip title="Duplicate this operation">
                          <IconButton
                            aria-label="Duplicate"
                            onClick={() => handleAddRowOperations(index, obj)}
                            disabled={isLastProduction}
                          >
                            <ControlPointDuplicateIcon />
                          </IconButton>
                        </Tooltip>
                        <IconButton
                          aria-label="Delete"
                          onClick={() => handleDeleteOperation(index)}
                          disabled={isLastProduction}
                        >
                          <DeleteForeverIcon color="error" />
                        </IconButton>
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', pt: 2 }}>
              <Button
                onClick={handleFormSubmit}
                disabled={isDisabled}
                color="info"
                size="small"
                endIcon={<CheckCircleIcon />}
                variant="contained"
              >
                Submit
              </Button>
            </Box>
          </>
        )}
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {/* add oprations */}
      <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="md" fullWidth>
        <DialogTitle>Select Operations</DialogTitle>
        <DialogContent>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <Autocomplete
                size="small"
                fullWidth
                options={[{ op_group_name: 'All Groups' }, ...opGroupData]}
                getOptionLabel={(obj) => (obj ? obj.op_group_name : '')}
                isOptionEqualToValue={(option, value) => option?.OP_group_id === value?.OP_group_id}
                renderInput={(params) => <TextField {...params} label="Operation Group" />}
                value={opGroupSelected}
                onChange={(e, newValue) => {
                  setOpGroupSelected(newValue);
                  setFieldErrors((prevFieldErrors) => ({
                    ...prevFieldErrors,
                    setOpGroupSelected: !newValue,
                  }));
                }}
              />
              {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )}
            </FormControl>
          </Stack>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Search"
                size="small"
                onChange={handleSearchTerm}
                value={searchTerm}
              />
              {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )}
            </FormControl>
          </Stack>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">S.No</TableCell>
                  <TableCell>Operation</TableCell>
                  <TableCell>Machine</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredOperations.map((obj, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{obj.OperationName}</TableCell>
                    <TableCell align="left">{obj.Machine_name}</TableCell>
                    <TableCell align="left">{obj.emp_role === 'O' ? 'Operator' : 'Helper'}</TableCell>
                    <TableCell align="center" sx={{ padding: '0' }}>
                      <Checkbox
                        checked={selectedOperations.includes(obj.OperationId)}
                        onChange={() => handleCheckboxChange(obj.OperationId)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="secondary">
            Cancel
          </Button>
          {selectedOperations.length > 0 && (
            <Button onClick={handleAddOperations} color="primary">
              Add Selected
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* delete confirmation popup dialog box */}
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen={fullScreen}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">{'Are you sure want clear the record?'}</DialogTitle>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={() => handleDeleteConfirmed()} color="error" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
